import React from 'react';
import { motion } from 'framer-motion';
const ebooks = [{
  image: 'https://cdn.magicpatterns.com/uploads/wdx7bJB9DoZEKW1hFUje4C/6._MOCKUP_NINOS_COMEN_FELICES.png',
  title: 'Niños Comen Felices',
  benefit: 'Mejora la relación de tu hijo con la comida sin luchas ni presión. Estrategias respetuosas para una alimentación consciente en familia.',
  color: 'bg-[#F5F0E8]'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5CRYnhie5w7Kuxeevksuq3/7._MOCKUP_NINOS_ORDENADOS_.png',
  title: 'Niños Ordenados',
  benefit: 'Fomenta el orden y la colaboración en casa con hábitos diarios que tu hijo puede adoptar con alegría y autonomía.',
  color: 'bg-[#FBF8F4]'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5LcxWiuPB8Lt2UCbErfZt8/8._MOCKUP_NINOS_EDUCADOS.png',
  title: 'Niños Educados',
  benefit: 'Educación basada en respeto, valores y convivencia sana. Herramientas para criar niños amables, seguros y empáticos.',
  color: 'bg-[#F5F0E8]'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8C4ALoETZimiTzjPe4n1do/9._MOCKUP_FORTALEZA_INFANTIL.png',
  title: 'Fortaleza Infantil',
  benefit: 'Fortalece la autoestima y resiliencia emocional de tu hijo. Límites claros con amor y seguridad para toda la vida.',
  color: 'bg-[#FBF8F4]'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/i6R5UHitPo3dx8CpDfBuoe/10._MOCKUP_PALABRAS_Y_SU_TIEMPO.png',
  title: 'Palabras y su Tiempo',
  benefit: 'Acompaña el desarrollo del lenguaje de tu hijo sin presión. Comprende sus tiempos y estimula con respeto y paciencia.',
  color: 'bg-[#F5F0E8]'
}];
export function EbookShowcasePart2() {
  return <section className="py-24 px-4 bg-[#FBF8F4]" data-id="element-34">
      <div className="max-w-6xl mx-auto" data-id="element-35">
        <div className="text-center mb-20" data-id="element-36">
          <h2 className="font-serif text-3xl md:text-4xl text-[#3D3229] mb-4" data-id="element-37">
            El resto del pack: herramientas para el día a día
          </h2>
          <p className="text-[#5C4A3A] max-w-2xl mx-auto" data-id="element-38">
            Cada guía aborda un desafío específico con soluciones que puedes
            aplicar desde hoy.
          </p>
        </div>

        <div className="space-y-24" data-id="element-39">
          {ebooks.map((ebook, index) => <motion.div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12 lg:gap-20`} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-40">
              {/* Image Side */}
              <div className="w-full lg:w-1/2 flex justify-center" data-id="element-41">
                <div className="relative w-full max-w-md aspect-[4/5]" data-id="element-42">
                  <div className={`absolute inset-0 ${ebook.color} rounded-3xl -rotate-3 scale-105 -z-10`} data-id="element-43" />
                  <img src={ebook.image} alt={ebook.title} className="w-full h-full object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-44" />
                </div>
              </div>

              {/* Content Side */}
              <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-45">
                <span className="inline-block text-[#5A7D60] font-medium tracking-wider text-sm uppercase mb-4" data-id="element-46">
                  E-book #{index + 6}
                </span>
                <h3 className="font-serif text-3xl md:text-4xl text-[#3D3229] mb-6 leading-tight" data-id="element-47">
                  {ebook.title}
                </h3>
                <p className="text-lg text-[#5C4A3A] leading-relaxed mb-8" data-id="element-48">
                  {ebook.benefit}
                </p>
                <div className="w-full h-px bg-[#EBE5DB] mb-8" data-id="element-49" />
                <ul className="space-y-3 text-[#5C4A3A]/80" data-id="element-50">
                  <li className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-51">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#5A7D60]" data-id="element-52" />
                    Lectura rápida y práctica
                  </li>
                  <li className="flex items-center gap-3 justify-center lg:justify-start" data-id="element-53">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#5A7D60]" data-id="element-54" />
                    Estrategias aplicables hoy mismo
                  </li>
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}